import styles from "./styles.module.scss";

function Intro() {
    return (
        <>
            <section className={styles.container}>
                <div className={styles.glitch} data-text="CABINET DE CONSEIL A TAILLE HUMAINE">CABINET DE CONSEIL A TAILLE HUMAINE</div>
                <div className={styles.paragraphs}>
                    <div className={styles.text}>OrgaExpert est un cabinet de conseil dont le métier est d’accompagner ses clients privés ou publics dans la formalisation et la mise en place de leurs projets de transformation digitale.</div>
                    <div className={styles.text}>Véritable pôle de compétences et laboratoire d’idées, constitué de collaborateurs éprouvés aux métiers du digital. OrgaExpert dispose des expertises et outils propres à lui assurer une intervention adéquate et efficace auprès de ses clients soucieux d’une intégration réussie, fluide et durable des technologies digitales dans l’ensemble ou une partie de leurs activités.</div>
                    <div className={styles.text}>Editeur de solutions digitales personnalisées et innovantes, nous intervenons dans la conception et la mise en oeuvre de projets du numérique, à travers une démarche de conseil et d’accompagnement ciblée, qui tient compte du capital humain et structurel présent et le fait évoluer en cohérence avec la stratégie digitale de l’organisation.</div>
                </div>

                <div className={styles.miniTitle}>PARTENAIRE DE VOS PROJETS IT</div>

                {/* <div className={styles.link}>             
                        <ul>
                            <li>
                                <a className={styles.animated_arrow} href="#">
                                    <span className={styles.the_arrow +" "+ styles.left}>
                                        <span className={styles.shaft}></span>
                                    </span>
                                    <span className={styles.main}>
                                        <span className={styles.text}>
                                            EN SAVOIR PLUS
                                        </span>
                                        <span className={styles.the_arrow +" " + styles.right}>
                                            <span className={styles.shaft}></span>
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>            
                </div> */}
            </section>
        </>
    )
}

export default Intro;